import styled from 'styled-components';
import { breakpoints, pxToRems } from '@awaze/design-system.utils.react';
export const Locations = styled.div `
  margin-top: ${pxToRems(24)};
  padding: ${pxToRems(8)};
  align-self: flex-start;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(${pxToRems(150)}, 1fr));
  gap: ${pxToRems(12)} ${pxToRems(50)};

  > * {
    white-space: nowrap;
  }
`;
export const Body = styled.div `
  width: 100%;
  padding: 0 ${pxToRems(16)} ${pxToRems(40)} ${pxToRems(16)};

  @media (min-width: ${breakpoints[0]}px) {
    padding: 0 ${pxToRems(60)} ${pxToRems(40)} ${pxToRems(60)};
  }
`;
//# sourceMappingURL=location-selector.styles.js.map